import React from "react";

import Article from "components/Templates/Article";
import allHeaders from "components/Properties/AllHeaders";
import allHashTags from "components/Properties/AllHashTags";

const header = {
  ...allHeaders["freeResumeBuilders"],
  ...allHashTags,
  channel: "33"
};

const data = [
  {
    type: "subheading",
    name: "introduction",
    title: "Free or Free Trial ?"
  },
  {
    type: "text",
    content:
      "There are tons of resumer builders out there but eveything comes with a catch. Often, people spend lot of time editing the resume and end up with a resume that is not ATS friendly or you are tricked to pay for the download."
  },
  {
    type: "text",
    content:
      "This quick guide will provide a comparison of top 5 free resume builders, their pros and cons and helps you to choose the best resumer builder without wasting time of Job seekers."
  },
  {
    type: "googleAd",
    position: "middle1"
  },
  {
    type: "subheading",
    name: "free-resume-builders-resumenow",
    title: "5 - Resumenow"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' /><h3>Website: <MyLink class='homelink' href='https://www.resume-now.com' target='_blank'>" +
      "Resumenow</MyLink></h3> " +
      "<b>Pros:</b>"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' /><ul><li>ATS Friendly</li>" +
      "<li>AI powered builder</li>" +
      "<li>Interview Preparation</li></ul>"
  },
  {
    type: "text",
    content:
      "<b>Cons:</b>"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' /><ul><li>No free tier for resume downloads</li>" +
      "<li>Misleading free advertisement</li>" +
      "<li>Signup Required</li>" +
      "<li>May endup paying for the subscription</li></ul>"
  },
  {
    type: "subheading",
    name: "free-resume-builders-canva",
    title: "4 - Canva"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' /><h3>Website: <MyLink class='homelink' href='https://www.canva.com' target='_blank'>" +
      "Canva</MyLink></h3> " +
      "<b>Pros:</b>"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' /><ul><li>Lots of free templates to choose</li>" +
      "<li>Drag and drop interface</li></ul>"
  },
  {
    type: "text",
    content:
      "<b>Cons:</b>"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' /><ul><li>ATS fails to recognize these templates</li>" +
      "<li>Signup Required</li>" +
      "<li>PDFs are downloaded as images which are not ATS friendly</li>" +
      "<li>Lots of features are hidden behind a paywall</li></ul>"
  },
  {
    type: "subheading",
    name: "free-resume-builders-zety",
    title: "3 - Zety"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' /><h3>Website: <MyLink class='homelink' href='https://www.zety.com' target='_blank'>" +
      "Zety</MyLink></h3> " +
      "<b>Pros:</b>"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' /><ul><li>Many resume templates to choose</li>" +
      "<li>Many cover letter templates</li>" +
      "<li>ATS Friendly</li></ul>"
  },
  {
    type: "text",
    content:
      "<b>Cons:</b>"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' /><ul><li>Signup Required</li>" +
      "<li>Provides only TXT format for free</li>" +
      "<li>Need to pay for PDF download</li></ul>"
  },
  {
    type: "googleAd",
    position: "middle2"
  },
  {
    type: "subheading",
    name: "free-resume-builders-flowcv",
    title: "2 - FlowCV"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' /><h3>Website: <MyLink class='homelink' href='https://www.flowcv.com' target='_blank'>" +
      "FlowCV</MyLink></h3> " +
      "<b>Pros:</b>"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' /><ul><li>1 Free Resume</li>" +
      "<li>ATS Friendly</li>" +
      "<li>No Paywall</li>" +
      "<li>Cover Letter Builder</li></ul>"
  },
  {
    type: "text",
    content:
      "<b>Cons:</b>"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' /><ul><li>Signup Required</li>" +
      "<li>Provides only 1 resume for free</li>" +
      "<li>Limited templates</li></ul>"
  },
  {
    type: "subheading",
    name: "free-resume-builders-tinyresumebuilder",
    title: "1 - TinyResumeBuilder"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' /><h3>Website: <MyLink class='homelink' href='https://www.tinyresumebuilder.com' target='_blank'>" +
      "TinyResumeBuilder</MyLink></h3> " +
      "<b>Pros:</b>"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' /><ul><li>All templates are free</li>" +
      "<li>ATS Friendly</li>" +
      "<li>No Paywall</li>" +
      "<li>Download as PDF/HTML for free</li>" +
      "<li>No Signup Required</li>" +
      "<li>Provides unlimited downloads</li>" +
      "<li>Lot of templates to choose</li>" +
      "<li>Cover Letter Builder</li>" +
      "<li>7 different color themes for each template</li></ul>"
  },
  {
    type: "text",
    content:
      "<b>Cons:</b>"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' /><ul><li>None</li></ul>"
  },
  {
    type: "subheading",
    name: "free-resume-builders-comparison",
    title: "Comparison"
  },
  {
    type: "text",
    content: "<div class='lineBreak' /><table class='comparison-table'>" +
      "<tr><th>Feature</th><th>ResumeNow</th><th>Canva</th><th>Zety</th><th>FlowCV</th><th>TinyResumeBuilder</th></tr>" +
      "<tr><td>Free PDF Download</td><td>❌ No</td><td>✅ Yes (as Image)</td><td>❌ No (TXT only)</td><td>✅ Yes (1 resume)</td><td>✅ Yes (Unlimited)</td></tr>" +
      "<tr><td>ATS Friendly</td><td>✅ Yes</td><td>❌ No</td><td>✅ Yes</td><td>✅ Yes</td><td>✅ Yes</td></tr>" +
      "<tr><td>Signup Required</td><td>❌ Required</td><td>❌ Required</td><td>❌ Required</td><td>❌ Required</td><td>✅ Not Required</td></tr>" +
      "<tr><td>Free Templates</td><td>Limited</td><td>✅ Many</td><td>✅ Many</td><td>Limited</td><td>✅ Many</td></tr>" +
      "<tr><td>Cover Letter Builder</td><td>✅ Yes</td><td>❌ No</td><td>✅ Yes</td><td>✅ Yes</td><td>✅ Yes</td></tr>" +
      "<tr><td>Paywall</td><td>❌ Yes</td><td>❌ Yes</td><td>❌ Yes</td><td>✅ No</td><td>✅ No</td></tr>" +
      "</table>"
  },
  {
    type: "subheading",
    name: "free-resume-builders-verdict",
    title: "Verdict"
  },
  {
    type: "text",
    content: "<div class='lineBreak' />" +
      "If you are creative and ok with PDF download as image for for <b>canva</b>, or if you are ok with TXT format, go with <b>zety</b>. if you are looking for a robust paid service with lots of AI features, " +
      "go with <b>resume-now</b>. If you ok with signup and 1 free resume, go with <b>flowcv</b>. If you are looking for a 100% free resume builder with no signup, paywall and hassle free and easy to use, go with <b>tinyresumebuilder</b>"
  },
  {
    type: "googleAd",
    position: "middle4"
  },
  {
    type: "text",
    content: "<div class='lineBreak' />"
  },
  {
    type: "footnote"
  },
  {
    type: "navLinks",
    previousURL: "/2-ways-to-run-ollama-deepseek-r1-tulu3-locally/",
    previousText: "2 Ways to run Ollama with DeepSeek-R1 or Tulu-3 locally - Using Docker and Directly on Local Machine",
    nextURL: "/convert-p12-to-jks-and-pem-to-jks/",
    nextText: "Convert PKCS#12 to JKS and PEM to JKS format"
  }
];

class FreeResumeBuilders extends React.Component {
  render() {
    return (
      <>
        <Article header={header} data={data} />a
      </>
    );
  }
}

export default FreeResumeBuilders;
